import { createAction } from 'redux-actions';

const ENTITY = '@@SYS';

export const addNotification = createAction(`${ENTITY}/ADD_NOTIFICATION`);
export const removeNotifications = createAction(`${ENTITY}/REMOVE_NOTIFICATIONS`);
export const checkCurrentVersion = createAction(`${ENTITY}/CHECK_CURRENT_VERSION`);

export default { addNotification, removeNotifications };
